import React from 'react';
import cn from 'classnames';

import s from './ExclusiveAvatarButton.scss';

export interface Props {
  /** Button text content */
  children: React.ReactNode;
  /** Click handler */
  onClick?: () => void;
  /** Additional CSS class */
  className?: string;
  /** Button type */
  type?: 'button' | 'submit' | 'reset';
  /** Disabled state */
  disabled?: boolean;
}

const ExclusiveAvatarButton: React.FC<Props> = ({
  children,
  onClick,
  className,
  type = 'button',
  disabled = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn(className, s['root'])}
    >
      <span className={s['inner']}>{children}</span>
    </button>
  );
};

ExclusiveAvatarButton.displayName = 'ExclusiveAvatarButton';

export default ExclusiveAvatarButton;
